import { Modal, Button } from "react-bootstrap";

const LocationAlertModal = ({ companyName, show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Aviso</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                A localização da empresa: <strong>{companyName}</strong> não está disponível.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LocationAlertModal;